import { motion } from "framer-motion";
import { WHY, IMG } from "../data/content";
import { Reveal, Eyebrow } from "./Reveal";

export const Why = () => (
  <section id="about" data-testid="why-section" className="relative bg-white text-[#0B0C10] py-24 sm:py-32">
    <div className="mx-auto max-w-[1440px] px-5 sm:px-8 grid lg:grid-cols-12 gap-10 lg:gap-16">
      <div className="lg:col-span-5">
        <div className="lg:sticky lg:top-28">
          <Reveal>
            <Eyebrow light>Why LHGS</Eyebrow>
            <h2 className="mt-5 font-display font-black text-4xl sm:text-5xl lg:text-6xl tracking-[-0.03em] leading-[0.95]">
              Documented, <br />not just done.
            </h2>
            <p className="mt-6 text-base sm:text-lg text-zinc-700 leading-relaxed max-w-md">
              Built specifically for the way property managers, condominium corporations, and commercial building managers actually operate across Ottawa.
            </p>
          </Reveal>
          <Reveal delay={0.15}>
            <div className="mt-10 relative aspect-[16/11] rounded-[4px] overflow-hidden bg-zinc-200 [clip-path:polygon(0_0,100%_0,100%_86%,88%_100%,0_100%)]">
              <img src={IMG.carpentry} alt="LHGS carpentry work in progress" className="absolute inset-0 h-full w-full object-cover" />
            </div>
          </Reveal>
        </div>
      </div>
      <div className="lg:col-span-7 flex flex-col">
        {WHY.map((w, i) => (
          <motion.div
            key={w.no}
            data-testid={`why-card-${w.no}`}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.7, delay: i * 0.05, ease: [0.22, 1, 0.36, 1] }}
            className="group relative border-t border-zinc-200 py-10 sm:py-12 grid grid-cols-[auto_1fr] gap-6 sm:gap-10 last:border-b"
          >
            <span className="absolute left-0 top-0 h-[2px] w-0 bg-[#FF6B00] transition-[width] duration-700 group-hover:w-full" />
            <span className="font-mono text-sm text-[#C2410C] pt-2">{w.no}</span>
            <div>
              <h3 className="font-display font-bold text-3xl sm:text-4xl tracking-tight transition-transform duration-500 group-hover:translate-x-2">{w.title}</h3>
              <p className="mt-3 text-base sm:text-lg text-zinc-700 leading-relaxed max-w-xl">{w.body}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
